// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-page[data-v-62b6968a]{display:flex;flex-direction:column}.home-page__section[data-v-62b6968a]{min-height:0}.home-page__section--fill[data-v-62b6968a]{display:flex;flex:0 0 auto;flex-direction:column;min-height:0;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
